module.exports = __webpack_public_path__ + "img/GH-syoukai-top-image-SP001.a509495d.webp";